import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import FormContainer from "../../../../../../common/components/form_container";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import { DropDown } from "../../../../../../common/domain/models/dropdown";
import { defaultReportLogAcessoSistemaForm, ReportLogAcessoSistemaForm, ReportLogAcessoSistemaSchema } from "../../../schemas/reports/logAcessoSistemaReport";
import { DefaultFormAutocomplete } from "../../../../../../common/components/default_form_autocomplete";

/**
 * ReportLogAcessoSistemaModal
 */

type Props = {
  open: boolean;
  loading: boolean;
  saving: boolean;
  ddlUsuarios: DropDown[];

  onClose: (openState: boolean) => void;
  onSubmit: (form: ReportLogAcessoSistemaForm) => void;
};

export const ReportLogAcessoSistemaModal = ({
  open,
  loading,
  saving,
  ddlUsuarios,

  onClose,
  onSubmit,
}: Props) => {

  const hookForm = useForm<ReportLogAcessoSistemaForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: defaultReportLogAcessoSistemaForm,
    resolver: zodResolver(ReportLogAcessoSistemaSchema),
  });


  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title={'Relatório Log Acesso Sistema'}
      width='70rem'
      confirmButtonLabel='Gerar relatório'
      confirmSavingButtonLabel='Gerando relatório...'
      savingLabel="Gerando"
      onClose={() => onClose(false)}
      onSubmit={hookForm.handleSubmit(onSubmit)}>
      <div className="w-full grid grid-cols-2 grid-rows-1 gap-2 p-4">
        <div className="col-span-6">
          <FormContainer title={"Informações"} arrangement="fullRow">
            <>
              <DefaultFormAutocomplete
                name='idUsuario'
                label='Usuário'
                options={ddlUsuarios}
                getOptionKey={x => x.id}
                getOptionLabel={x => x.title}
                reactHookForm={hookForm} />

              <div>
                <div className="w-full flex gap-1">
                  <FormDatePickerInput
                    name='dataDe'
                    label='Data De'
                    reactHookForm={hookForm} />

                  <FormDatePickerInput
                    name='dataAte'
                    label='Data Ate'
                    reactHookForm={hookForm} />
                </div>
              </div>
            </>
          </FormContainer>
        </div>

      </div>
    </BaseFormControlledModal>
  );
}